var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('header',[_c('h1',{staticClass:"title has-text-white has-text-weight-light is-size-1 is-size-2-mobile py-0 my-2"},[_vm._v(_vm._s(_vm.$t("navigation.not_found")))])])])}
var staticRenderFns = []

export { render, staticRenderFns }